import React from 'react'
import { Box, IconButton, Modal } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import SearchCard from '../discover/elements/SearchCard'
import SearchCardResults from '../discover/elements/SearchCardResults'
import { useDispatch, useSelector } from 'react-redux'
import { selectSearchPopup, setShowSearch } from '../../actions/mainSlice'


const SearchDialog = () => {
    const dispatch = useDispatch()
    const open = useSelector(selectSearchPopup)

    const handleModal = (open: boolean) => {
        dispatch(setShowSearch({showSearch: open}))
    }

    return (
        <>
            <IconButton sx={{backgroundColor: '#fff!important'}} onClick={() => handleModal(true)}>
                <SearchIcon color='primary'/>
            </IconButton>
            <Modal
                    open={open}
                    onClose={() => handleModal(false)}
                    aria-labelledby="modal-search"
                    aria-describedby="modal-search-results"
                    sx={{}}
                >
                <Box sx={{
                    background: '#00000030!important',
                    borderRadius: '16px',
                    position: 'absolute',
                    bottom: '0px',
                    left: '50%',
                    transform: 'translate(-50%, 0%)',
                    backdropFilter: 'blur(1.5rem)',
                    width: '100%',
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    maxHeight: '95vh',
                    transition: 'max-height 0.15s ease-out',
                    boxShadow: 24,
                    overflow: 'hidden',
                    }}>
                        <SearchCardResults closeModale={() => handleModal(false)} />
                        <SearchCard />
                </Box>
            </Modal>
        </>
    )
}

export default SearchDialog